import React from 'react';
import { Typography } from 'antd';
import { connect } from 'react-redux';
import { getLoggedInUser } from 'utilities/helpers';
const { Title, Paragraph } = Typography;

const WelcomeSection = () => {
  const user = getLoggedInUser();
  return (
    <section className="!mt-12 md:!mt-24 mb-12">
      <div className="">
        <Title level={2} className="mb-1 tracking-normal !text-xl md:!text-3xl">
          Welcome back, {user?.user_details?.first_name}{' '}
          <span className="inline-block wave-animation">👋</span>
        </Title>
        <Paragraph
          className="text-sm font-medium !leading-relaxed"
          style={{ marginBottom: '2.5rem' }}
        >
          {`Ready to make today count? Here's your productivity dashboard.`}
        </Paragraph>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(WelcomeSection);
